<template>
  <div class="micro-page-add">
    <div v-if="firstContent === true" class="main-content">
      <div class="left-choose">
        <el-tabs v-model="activeName" style="width: 300px;">
          <el-tab-pane label="客户属性" name="first">
            <div class="attr-content">
              <div class="nav-tips">如想添加客户属性，可取设置中心-<span>客户属性</span>添加</div>
              <div v-for="(item, index) in attrs" :key="index" :class="item.choosed === true ? 'choosed' : ''" class="attr-item" @click="addAttr(item)">
                <span v-if="item.name.length <= 7">{{ item.name }}</span>
                <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom" v-if="item.name.length > 7">
                  <span>{{ item.name }}</span>
                </el-tooltip>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="其他设置" name="second">
            <div class="other-set">
              <div @click="openEditerDialog">富文本</div>
              <div @click="openSetAttrDialog">自定义字段</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
        <div class="right-show">
          <div class="phone-content">
            <div class="show-content">
              <!--顶部标题设置-->
              <div class="top-title" style="box-sizing: content-box;">
                <div @click="openEditTitle">
                  <el-input class="title-input" v-model="titleNameSend" placeholder="请输入标题名称"></el-input>
                  <!-- <span v-if="titleName === ''">点击更改页面标题</span>
                  <span v-if="titleName !== ''">{{ titleName }}</span> -->
                </div>
              </div>
              <!--图片设置-->
              <el-upload
                class="avatar-uploader-phone"
                name="file_upload"
                :action="uploadURL"
                title="可以点击图片进行换图"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="phoneImg" :src="phoneImg" class="useNowPhoneImg">
                <img v-if="phoneImg === ''" src="../../assets/images/Group.png" alt="" class="defaultPhoneImg">
                <div v-if="phoneImg === ''" slot="tip" class="el-upload__tip" style="width:100%">请选择1M以下，支持上传jpg/png文件</div>
              </el-upload>
              <!--添加的属性内容-->
              <div class="add-attr-content">
                <draggable v-model="attrPhoneArray" :options="{group:'people'}" @start="drag=true" @end="drag=false">
                  <div @mouseover="showModel(item)" @mouseout="hideModel(item)" class="attr-phone-item" v-for="(item, index) in attrPhoneArray" :key="index">
                    <el-input v-if="item.type=='input'" disabled v-model="item.val" :placeholder="item.label"></el-input>
                    <el-select v-if="item.type=='select'" disabled v-model="item.val" :placeholder="item.label">
                      <el-option v-for="(one,i) in option" :key="i" :label="one" :value="one"></el-option>
                    </el-select>
                    <el-input v-if="item.type=='number'" type="number" disabled v-model="item.val" :placeholder="item.label"></el-input>
                    <el-input v-if="item.type=='model'" disabled v-model="item.val" :placeholder="item.label"></el-input>
                    <!--radio转为select-->
                    <div v-if="item.type=='radio'" class="radio-name">{{ item.name }}</div>
                    <el-radio-group class="radio-content" v-if="item.type=='radio'" disabled v-model="item.val" :placeholder="item.label">
                      <el-radio v-for="(one,i) in item.option" :key="i" :label="one">{{ one }}</el-radio>
                    </el-radio-group>
                    <el-input
                      v-if="item.type=='textarea'"
                      type="textarea"
                      disabled
                      autosize
                      :placeholder="item.label"
                      v-model="item.val">
                    </el-input>
                    <!--checkbox-->
                    <div v-if="item.type=='checkBox'" class="checkbox-name">{{ item.name }}</div>
                    <el-checkbox-group v-if="item.type=='checkBox'" v-model="item.val">
                      <el-checkbox disabled v-for="(one, i) in item.option" :key="i" :label="one"></el-checkbox>
                    </el-checkbox-group>
                    <el-date-picker
                      class="date-style"
                      v-if="item.type=='datePicker'"
                      v-model="item.val"
                      type="date"
                      disabled
                      value-format="yyyy-MM-dd"
                      :placeholder="item.label">
                    </el-date-picker>
                    <el-date-picker
                      class="date-style"
                      v-if="item.type=='dateTimePicker'"
                      v-model="item.val"
                      type="datetime"
                      disabled
                      value-format="yyyy-MM-dd"
                      :placeholder="item.label">
                    </el-date-picker>
                    <el-select
                      v-if="item.type=='addressPicker'"
                      :options="addressOptions"
                      disabled
                      :placeholder="item.label"
                      v-model="item.val">
                    </el-select>
                    <div class="ele-div" v-show="item.type==='div'" v-html="item.option"></div>
                    <!--鼠标划上去蒙层-->
                    <div class="item-model" v-show="item.itemShowModel === true">
                      <div @click="deleteAttrItemPhone(item, index)" class="item-model-content">
                        <span class="iconfont icon-shanchu"></span>
                        <span>删除</span>
                      </div>
                      <div v-if="item.itemMustWrite === false" @click="setMustWrite(item)" class="item-model-content">
                        <span style="font-size: 36px;padding-top: 4px;height: 10px;">*</span>
                        <span>必填</span>
                      </div>
                      <div v-if="item.itemMustWrite === true" @click="cancelMustWrite(item)" class="item-model-content">
                        <span style="font-size: 36px;padding-top: 4px;height: 10px;">*</span>
                        <span>取消必填</span>
                      </div>
                    </div>
                    <!--必填星号-->
                    <div class="must-write" v-if="(item.itemMustWrite === true && item.type !=='radio') || (item.is_require === 1 && item.type !=='radio')">*</div>
                    <div class="must-write-radio" v-if="(item.itemMustWrite === true  && item.type ==='radio') || (item.is_require === 1  && item.type ==='radio')">*</div>
                  </div>
                </draggable>
                <!--提交按钮-->
                <div class="submit-btn">提交</div>
              </div>
            </div>
          </div>
          <el-button class="next-step-btn" @click="firstToSecond" style="margin: 20px auto;float: none">下一步</el-button>
        </div>
      </div>
      <!--第二步-->
      <div v-if="secondContent === true" class="second-content form-submit-page" style="margin-top: 20px; background-color: #fff; overflow-y: hidden;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm box-content-form">
          <!-- <el-form-item label="关联公众号:" prop="bindPublic">
            <el-select v-model="ruleForm.bindPublic" placeholder="请关联公众号">
              <el-option
                v-for="item in publics"
                :key="item.id"
                :disabled="item.disabled"
                :label="item.nick_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="内部名称:" prop="admin_title">
            <el-input type="input" placeholder="请输入内部名称，客户不可见" maxlength="50" v-model="ruleForm.admin_title"></el-input>
          </el-form-item>
          <el-form-item label="权限设置:" prop="canDo">
            <el-checkbox-group @change="knows" v-model="ruleForm.canDo" class="canDo-setting">
              <!--<el-checkbox label="只能在微信打开" name="canDo" style="margin-left: 0"></el-checkbox>-->
              <el-checkbox label="禁止分享" name="canDo" style="margin-left: 0"></el-checkbox>
              <el-checkbox label="访问页面时请求授权" name="canDo"></el-checkbox>
              <el-checkbox label="每个用户限填一次" name="canDo"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="提交限制:" prop="submitLimit">
            <el-input placeholder="0不限制，大于0时限制" v-model.number="ruleForm.submitLimit"></el-input>
            <div class="tips" style="text-align: left">0不限制，大于0时限制</div>
          </el-form-item>
          <el-form-item label="标签:" class="picture-text-item">
            <tags-template v-model="tagsArray"></tags-template>
          </el-form-item>
          <el-form-item label="手机验证:" class="isMobileCode" prop="isVerifyMobile">
            <el-radio-group v-model="ruleForm.isVerifyMobile" style="margin-top: 0">
              <el-radio :label="1" style="margin-left: 0;">是</el-radio>
              <el-radio :label="0" style="margin-left: 10px;">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="跳转链接:" prop="link">
            <el-input type="url" placeholder="请输入提交成功后的跳转链接" v-model="ruleForm.link"></el-input>
          </el-form-item>
          <el-form-item label="成功提示:" prop="tips">
            <el-input :maxlength="50" type="input" placeholder="请输入提交成功后的提示" v-model="ruleForm.tips"></el-input>
          </el-form-item>
          <el-form-item label="客户来源:" prop="customerSource">
            <el-select v-model="ruleForm.customerSource" placeholder="请选择客户来源">
              <el-option
                v-for="item in sources"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源说明" prop="sourceDesc">
            <el-input type="textarea" v-model="ruleForm.sourceDesc"></el-input>
          </el-form-item>
          <el-form-item>
            <div style="display: flex; justify-content: flex-start; flex-direction: row">
              <el-button @click="toFirst" class="next-step-btn">上一步</el-button>
              <el-button class="confirm-btn" style="margin-top: 3px; margin-left: 10px;" @click="toThird">完成</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!--第三步-->
      <!-- <div v-if="thirdContent === true" class="third-content">
        <div class="publish-save-content">
          <div class="operation-tips">操作提示</div>
          <p style="margin-top: 30px;margin-bottom: 20px">保存为草稿状态或发布状态？</p>
          <div class="operation-content">
            <el-button type="primary" class="second-page-btn reply-btn-type" @click="save" style="float: none; background-color: #05B324;">保存</el-button>
            <el-button type="primary" class="second-page-btn reply-btn-type" @click="publish" style="float: none;background: #1980FF;border: 1px solid #FCA531;">发布</el-button>
          </div>
        </div>
        <div class="bottom-pre">
          <el-button @click="thirdToSecond">上一步</el-button>
        </div>
      </div> -->
      <el-dialog class="cellDialog" title="操作提示" :visible.sync="operationDialog" width="400px">
        <div>保存为草稿状态或发布状态？</div>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-confirm-btn" @click="save" style="margin-left: 20px; background-color: #05B324; color: #fff">保存草稿</el-button>
          <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px background-color: ##05B324;" @click="publish">发 布</el-button>
        </div>
      </el-dialog>
    <!--修改标题弹窗-->
    <!-- <el-dialog class="cellDialog base-dialog" @close="editTitle" title="修改页面标题" :visible.sync="editTitleDialog" width="520px">
      <el-form>
        <el-form-item label="标题名称" label-width="80px">
          <el-input maxlength="50" v-model.trim="titleName" placeholder="请输入标题名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="editTitles">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="confirmEditTitle">确 定</el-button>
      </div>
    </el-dialog> -->
    <!--富文本弹窗-->
    <el-dialog class="cellDialog base-dialog rich-text-dialog" title="插入内容" :visible.sync="editerDialog" width="725px">
      <el-form>
        <el-form-item label="" class="picture-text-item" prop="content">
          <el-upload class="pic-uploader" action="" :show-file-list="false" style="display: none;"></el-upload>
          <!--上面这个el-upload没有作用只是为了撑起form-->
          <editor v-model="ruleForm.content" class="picture-text-details" :action="uploadURL">
          </editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="editerDialog = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="confirmInsert" style="margin-right: 30px;">确 定</el-button>
      </div>
    </el-dialog>
    <!--自定义字段弹窗-->
    <el-dialog class="cellDialog setAttrDialog base-dialog" title="自定义字段设置" :visible.sync="adddialog" width="520px">
      <div class="tabs">
        <div @click="chooseType(index, item)" :class="tabIndex === index ? 'type-select' : ''" :key="index" v-for="(item, index) in types">
          {{ item.name }}
        </div>
      </div>
      <el-form ref="addForm" :model="addForm" style="margin-top: 20px">
        <!--文本-->
        <div v-if="addForm.type === 'text'">
          <el-form-item class="text-align-left" label="文本类型:" :label-width="addLabelWidth">
            <template>
              <el-radio-group @change="changeText" v-model="addForm.textType">
                <el-radio :label="1" style="margin-left: 0;">单行文本</el-radio>
                <el-radio :label="0" style="margin-left: 10px;">多行文本</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="字段名称:" :label-width="addLabelWidth">
            <el-input class="stockInput stock-input" placeholder="输入字段名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
        </div>
        <!--下拉菜单-->
        <div v-if="addForm.type === 'select'" :class="addMore ? 'addMore' : 'normal'">
          <el-form-item label="字段名称:" :label-width="addLabelWidth" style="padding-top: 0">
            <el-input class="stockInput stockInputSpe" placeholder="输入字段名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <div class="select-item" :key="index" v-for="(item, index) in addForm.select" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <div class="text-content">
                <el-input class="stockInput stockInputSpe" placeholder="输入选项" type="text" v-model="addForm.select[index]" auto-complete="off"></el-input>
                <div class="removeSelectItem" @click="removeSelectItem(index)">删除</div>
              </div>
            </el-form-item>
          </div>
          <div>
            <div class="addSelectItem" @click="addSelectItem">增加可选项</div>
          </div>
        </div>
        <!--时间-->
        <div v-if="addForm.type === 'datePicker' || addForm.type === 'dateTimePicker'">
          <el-form-item label="时间类型:" :label-width="addLabelWidth">
            <div class="date-type" style="margin-left: 0">
              <div :key="index" :class="dateTabIndex === index ? 'dateChoose' : ''" @click="chooseDateType(index, item)" v-for="(item, index) in timeChoose">
                {{ item.name }}
              </div>
            </div>
          </el-form-item>
          <div class="description-date" style="padding-left: 80px">
            <div v-if="dateTabIndex === 0">如：1977-01-01</div>
            <div v-if="dateTabIndex === 1">如：1977-01-01 23:59:59</div>
          </div>
          <el-form-item label="字段名称:" :label-width="addLabelWidth" style="padding: 20px 0 0 0">
            <el-input class="stockInput stockInputSpe" placeholder="输入字段名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
        </div>
        <!--单选-->
        <div v-if="addForm.type === 'radio'" :class="radioMore ? 'addMore' : 'normal'">
          <el-form-item label="字段名称:" :label-width="addLabelWidth">
            <el-input class="stockInput stock-input" placeholder="输入字段名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <div class="radio-item" :key="index" v-for="(item, index) in addForm.radio" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <div class="text-content">
                <el-input maxlength="15" class="stockInput stock-input" placeholder="请输入选项" type="text" v-model="addForm.radio[index]" auto-complete="off" @blur="judegValue(addForm.radio[index], item)"></el-input>
                <div class="removeSelectItem" @click="removeRadioItem(index)">删除</div>
              </div>
            </el-form-item>
          </div>
          <div>
            <div class="addSelectItem" @click="addRadioItem">增加可选项</div>
          </div>
        </div>
        <!--复选-->
        <div v-if="addForm.type === 'checkBox'" :class="checkBoxMore ? 'addMore' : 'normal'">
          <el-form-item label="字段名称:" :label-width="addLabelWidth">
            <el-input class="stockInput stock-input" placeholder="输入字段名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <div class="checkBox-item" :key="index" v-for="(item, index) in addForm.checkBox" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <div class="text-content">
                <el-input maxlength="15" class="stockInput stock-input" placeholder="输入选项" type="text" v-model="addForm.checkBox[index]" auto-complete="off" @blur="judegCheckBoxValue(addForm.checkBox[index], item)"></el-input>
                <div class="removeSelectItem" @click="removeCheckBoxItem(index)">删除</div>
              </div>
            </el-form-item>
          </div>
          <div>
            <div class="addSelectItem" @click="addCheckBoxItem">增加可选项</div>
          </div>
        </div>
      </el-form>
      <el-form ref="addForm" :model="addForm">
        <el-form-item class="text-align-left" label="是否必填:" :label-width="addLabelWidth">
          <template>
            <el-radio-group v-model="addForm.is_require">
              <el-radio :label="1" style="margin-left: 0;">是</el-radio>
              <el-radio :label="0" style="margin-left: 10px;">否</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="confirmAddAttr">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { getCustomerAttributeList, editWePage, getWechatPublicListAll, getCustomerSourceListForWepage, getWePageDetail, checkWeiPageTitle } from '@/api/customer.js'
import { getCusAttrList } from '@/api/set.js'
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import editor from '@/components/common/editor'
import tagsTemplate from '@/components/common/tags-template'
import draggable from 'vuedraggable'
export default {
  name: 'weixinManage',
  data () {
    let checkSubmitLimit = (rule, value, callback) => {
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字值'))
      } else {
        if (value < 0) {
          callback(new Error('提交限制不能小于0'))
        } else {
          callback()
        }
      }
    }
    return {
      tagsArray: [],
      operationDialog: false,
      activeName: 'first',
      checkBoxMore: false,
      radioMore: false,
      addMore: false,
      timeChoose: [
        {
          name: '日期',
          dateType: 'datePicker'
        },
        {
          name: '日期和时间',
          dateType: 'dateTimePicker'
        }
      ],
      dateTabIndex: 0,
      tabIndex: 0,
      types: [
        {
          name: '文本',
          type: 'text'
        },
        {
          name: '下拉菜单',
          type: 'select'
        },
        {
          name: '时间',
          type: 'datePicker'
        },
        {
          name: '单选',
          type: 'radio'
        },
        {
          name: '复选',
          type: 'checkBox'
        }
      ],
      addLabelWidth: '70px',
      addForm: {
        name: '',
        tags: '',
        score: '',
        type: 'text',
        identity: '',
        is_require: 0,
        textType: 1,
        select: [''],
        checkBox: [''],
        option: [],
        radio: [''],
        dateType: ''
      },
      isAttr: true,
      ruleForm: {
        admin_title: '',
        bindPublic: '',
        link: '',
        tips: '',
        canDo: [],
        customerSource: '',
        sourceDesc: '',
        isVerifyMobile: 0,
        submitLimit: 0,
      },
      publics: [],
      sources: [],
      attrs: [],
      phoneImg: '',
      editTitleDialog: false,
      editerDialog: false,
      adddialog: false,
      titleName: '',
      titleNameSend: '',
      attrPhoneArrayCoby: [],
      attrPhoneArray: [],
      option: [],
      addressOptions: regionDataPlus,
      secondContent: false,
      firstContent: true,
      thirdContent: false,
      rules: {
        admin_title: [
          { required: true, message: '请输入后台标题', trigger: 'blur' }
        ],
        bindPublic: [
          { required: true, message: '请选择关联的公众号', trigger: 'blur' }
        ],
        customerSource: [
          { required: true, message: '请选择客户来源', trigger: 'change' }
        ],
        isVerifyMobile: [
          { required: true, message: '请选择是否手机验证', trigger: 'blur' }
        ],
        link: [
          { type: 'url', message: '请填写正确的跳转链接', trigger: 'blur' }
        ],
        submitLimit: [
          { validator: checkSubmitLimit, trigger: 'blur' }
        ],
        sourceDesc: [
          { required: true, message: '请填写来源说明', trigger: 'blur' }
        ]
      },
      wechat_only: 0,
      authorization: 0,
      is_once: 0,
      is_share: 0,
      is_confirm: 0
    }
  },
  mounted () {
  },
  components: {
    draggable,
    editor,
    tagsTemplate
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  methods: {
    judegValue(val, item) {
      this.count = 0
      for (let i in this.addForm.radio) {
        if (val === this.addForm.radio[i]) {
          this.count++
        }
      }
      if (this.count > 1) {
        _g.toastMsg('error', '选项值不能相同')
      }
    },
    judegCheckBoxValue(val, item) {
      this.count = 0
      for (let i in this.addForm.checkBox) {
        if (val === this.addForm.checkBox[i]) {
          this.count++
        }
      }
      if (this.count > 1) {
        _g.toastMsg('error', '选项值不能相同')
      }
    },
    // 确认修改标题
    confirmEditTitle() {
      // this.titleNameSend = this.titleName
      this.editTitleDialog = false
      this.is_confirm = 1
    },
    // 关闭标题弹窗
    editTitle() {
      if (this.is_confirm === 0) {
        this.titleNameSend = ''
      } else {
        this.titleNameSend = this.titleNameSend
      }
    },
    // 关闭标题弹窗
    editTitles() {
      this.titleNameSend = ''
      this.editTitleDialog = false
    },
    // 切换文本类型
    changeText() {
      this.addForm.name = ''
    },
    // 确认插入富文本
    confirmInsert() {
      this.attrPhoneArray.push({
        name: this.fieldName(),
        label: '',
        type: 'div',
        itemShowModel: false,
        is_require: '',
        identity: this.fieldName(),
        option: this.ruleForm.content
      })
      this.attrPhoneArrayCoby = JSON.parse(JSON.stringify(this.attrPhoneArray))
      this.editerDialog = false
    },
    // 确认添加自定义属性
    confirmAddAttr() {
      if (this.addForm.type === 'text' || this.addForm.type === 'datePicker' || this.addForm.type === 'dateTimePicker') {
        this.addForm.option = []
      } else if (this.addForm.type === 'select') {
        this.addForm.option = this.addForm.select
      } else if (this.addForm.type === 'radio') {
        if (this.count > 1) {
          _g.toastMsg('error', '单选选项值不能相同')
          return
        }
        this.addForm.option = this.addForm.radio
      } else if (this.addForm.type === 'checkBox') {
        if (this.count > 1) {
          _g.toastMsg('error', '复选选项值不能相同')
          return
        }
        this.addForm.option = this.addForm.checkBox
      }
      if (this.addForm.type === 'text') {
        if (this.addForm.textType === 1) {
          this.attrPhoneArray.push({
            name: this.addForm.name,
            label: this.addForm.name,
            type: 'input',
            itemShowModel: false,
            option: this.addForm.option,
            identity: this.fieldName(),
            is_require: this.addForm.is_require
          })
        } else if (this.addForm.textType === 0) {
          this.attrPhoneArray.push({
            name: this.addForm.name,
            label: this.addForm.name,
            type: 'textarea',
            itemShowModel: false,
            option: this.addForm.option,
            identity: this.fieldName(),
            is_require: this.addForm.is_require
          })
        }
      } else {
        this.attrPhoneArray.push({
          name: this.addForm.name,
          label: this.addForm.name,
          type: this.addForm.type,
          itemShowModel: false,
          option: this.addForm.option,
          identity: this.fieldName(),
          is_require: this.addForm.is_require
        })
      }
      this.attrPhoneArrayCoby = JSON.parse(JSON.stringify(this.attrPhoneArray))
      this.adddialog = false
    },
    // 生成随机identity
    fieldName() {
      let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
        ''
      )
      let fieldName = 'field-'
      for (let i = 0; i < 6; i++) {
        fieldName = fieldName + chars[parseInt(Math.random() * 16)]
      }
      return fieldName
    },
    // 选择时间类型
    chooseDateType(index, item) {
      this.dateTabIndex = index
      this.addForm.type = item.dateType
    },
    // 打开自定义字段弹窗
    openSetAttrDialog() {
      this.adddialog = true
      // 清空弹窗内容
      this.addForm.name = ''
      this.addForm.type = 'text'
      this.tabIndex = 0
      this.addForm.identity = ''
      this.addForm.textType = 1
      this.addForm.is_require = 0
      this.addForm.select = ['']
      this.addForm.checkBox = ['']
      this.addForm.radio = ['']
    },
    // 删除添加checkBox可选项
    removeCheckBoxItem(index) {
      this.addForm.checkBox.splice(index, 1)
      if (this.addForm.checkBox.length === 1) {
        this.checkBoxMore = false
      }
    },
    // 增加添加checkBox可选项
    addCheckBoxItem() {
      if (this.count > 1) {
        _g.toastMsg('error', '选项值不能相同')
        return
      }
      this.addForm.checkBox.push('')
      this.checkBoxMore = true
    },
    // 增加添加radio可选项
    addRadioItem() {
      if (this.count > 1) {
        _g.toastMsg('error', '选项值不能相同')
        return
      }
      this.addForm.radio.push('')
      this.radioMore = true
    },
    // 增加添加select可选项
    addSelectItem() {
      this.addForm.select.push('')
      this.addMore = true
    },
    // 删除添加select可选项
    removeSelectItem(index) {
      this.addForm.select.splice(index, 1)
      if (this.addForm.select.length === 1) {
        this.addMore = false
      }
    },
    // 删除添加radio可选项
    removeRadioItem(index) {
      this.addForm.radio.splice(index, 1)
      if (this.addForm.radio.length === 1) {
        this.radioMore = false
      }
    },
    // 选择属性类型
    chooseType(index, item) {
      this.tabIndex = index
      this.addForm.type = item.type
      this.addForm.name = ''
    },
    // 打开富文本弹窗
    openEditerDialog() {
      this.editerDialog = true
      this.ruleForm.content = ''
    },

    // 点击其他设置
    notChooseAttr() {
      this.isAttr = false
    },
    // 点击客户属性
    chooseAttr() {
      this.isAttr = true
    },
    knows() {
    },
    // 保存
    save() {

      this.wechat_only = 1
      // 未设置禁止分享 1 设置禁止分享 0
      this.is_share = this.ruleForm.canDo.indexOf('禁止分享') > -1 ? 0 : 1
      // 设置访问授权 1 未设置访问授权 0
      this.authorization = this.ruleForm.canDo.indexOf('访问页面时请求授权') > -1 ? 1 : 0
      // 设置每个用户一次 1 未设置每个用户一次 0
      this.is_once = this.ruleForm.canDo.indexOf('每个用户限填一次') > -1 ? 1 : 0

      if (this.ruleForm.isVerifyMobile === 1) {
        for (let i = 0; i < this.attrPhoneArray.length; i++) {
          if (this.attrPhoneArray[i].identity === 'mobile') {
            this.attrPhoneArray.splice(i + 1, 0, {
              name: '手机验证',
              label: '手机验证',
              identity: 'verify_code',
              type: 'input'
            })
            i = i + 1
          }
        }
      }
      let id = this.$route.query.id
      editWePage(id, this.titleNameSend, this.phoneImg, this.$route.query.public_id, this.wechat_only, this.is_share, this.authorization, this.is_once, this.ruleForm.customerSource, this.ruleForm.sourceDesc, this.ruleForm.isVerifyMobile, 0, this.attrPhoneArray, this.ruleForm.link, this.ruleForm.tips, this.tagsArray, this.ruleForm.admin_title, this.ruleForm.submitLimit).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '编辑成功')
          router.push('/home/micro-page')
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.operationDialog = false
      })
    },
    // 发布
    publish() {
      this.wechat_only = 1
      // 未设置禁止分享 1 设置禁止分享 0
      this.is_share = this.ruleForm.canDo.indexOf('禁止分享') > -1 ? 0 : 1
      // 设置访问授权 1 未设置访问授权 0
      this.authorization = this.ruleForm.canDo.indexOf('访问页面时请求授权') > -1 ? 1 : 0
      // 设置每个用户一次 1 未设置每个用户一次 0
      this.is_once = this.ruleForm.canDo.indexOf('每个用户限填一次') > -1 ? 1 : 0

      if (this.ruleForm.isVerifyMobile === 1) {
        for (let i = 0; i < this.attrPhoneArray.length; i++) {
          if (this.attrPhoneArray[i].identity === 'mobile') {
            this.attrPhoneArray.splice(i + 1, 0, {
              name: '手机验证',
              label: '手机验证',
              identity: 'verify_code',
              type: 'input'
            })
            i = i + 1
          }
        }
      }
      let id = this.$route.query.id
      editWePage(id, this.titleNameSend, this.phoneImg, this.$route.query.public_id, this.wechat_only, this.is_share, this.authorization, this.is_once, this.ruleForm.customerSource, this.ruleForm.sourceDesc, this.ruleForm.isVerifyMobile, 1, this.attrPhoneArray, this.ruleForm.link, this.ruleForm.tips, this.tagsArray, this.ruleForm.admin_title, this.ruleForm.submitLimit).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '编辑成功')
          router.push('/home/micro-page')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 跳转到第一页
    toFirst() {
      this.secondContent = false
      this.firstContent = true
      this.thirdContent = false
    },
    // 第三步跳转到第二步
    thirdToSecond() {
      this.secondContent = true
      this.firstContent = false
      this.thirdContent = false
    },
    // 跳转到第三步
    toThird() {
      this.$refs.ruleForm.validate((pass) => {
        if (pass) {
          this.secondContent = true
          this.firstContent = false
          this.operationDialog = true
        }
      })
    },
    // 第一步跳到第二步
    firstToSecond() {
      if (this.titleNameSend === '') {
        _g.toastMsg('error', '请输入页面标题')
        return
      }
      if (this.phoneImg === '') {
        _g.toastMsg('error', '请上传图片')
        return
      }
      if (this.attrPhoneArray.length === 0) {
        _g.toastMsg('error', '请添加属性')
        return
      }
      let id = this.$route.query.id
      checkWeiPageTitle(this.titleNameSend, id).then(res => {
        if (res.data.code === 0) {
          this.secondContent = true
          this.firstContent = false
          this.thirdContent = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 设置为必填
    setMustWrite(item) {
      this.$confirm('确认设置该属性为必填?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.itemMustWrite = true
        item.is_require = 1
        for (let one of this.attrPhoneArrayCoby) {
          if (item.identity === one.identity) {
            one.itemMustWrite = item.itemMustWrite
            one.is_require = 1
          }
        }
      }).catch((error) => {
      })
    },
    // 设置为非必填
    cancelMustWrite(item) {
      this.$confirm('确认取消必填?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.itemMustWrite = false
        item.is_require = 0
        for (let one of this.attrPhoneArrayCoby) {
          if (item.identity === one.identity) {
            one.itemMustWrite = item.itemMustWrite
            one.is_require = 0
          }
        }
      }).catch((error) => {
      })
    },
    // 删除对应的显示在手机端的属性
    deleteAttrItemPhone(item, index) {
      this.$confirm('确认删除该属性?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let one of this.attrs) {
          if (one.identity === item.identity) {
            one.choosed = false
          }
        }
        this.attrPhoneArray.splice(index, 1)
        this.attrPhoneArrayCoby.splice(index, 1)
      }).catch((error) => {
      })
    },
    // 隐藏手机模态层
    hideModel(item) {
      item.itemShowModel = false
    },
    // 显示出手机模态层
    showModel(item) {
      item.itemShowModel = true
    },
    // 添加属性到右侧视图
    addAttr(item) {
      this.$confirm('确认添加该属性?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.attrPhoneArrayCoby.length === 0) {
          item.choosed = true
          this.attrPhoneArrayCoby.push(item)
          this.attrPhoneArray = JSON.parse(JSON.stringify(this.attrPhoneArrayCoby))
        } else {
          for (let one of this.attrPhoneArrayCoby) {
            if (one.identity === item.identity) {
              _g.toastMsg('error', '该属性已存在，请勿重复添加')
              return
            }
          }
          item.choosed = true
          this.attrPhoneArrayCoby.push(item)
          this.attrPhoneArray = JSON.parse(JSON.stringify(this.attrPhoneArrayCoby))
        }
      }).catch((error) => {
      })
    },
    // 打开修改页面标题弹窗
    openEditTitle() {
      this.editTitleDialog = true
    },
    // 切换图片
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.phoneImg = res.data.path
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        _g.toastMsg('上传图片只能是 JPG/PNG 格式!')
      }
      return (isJPG) || (isPNG)
    },
    // 请求客户属性列表
    load() {
      let modelId = this.$route.query.modelId
      // 获取属性列表
      let getAttr = getCusAttrList(modelId)
      // 获取公众号列表
      let getPublic = getWechatPublicListAll()
      // 获取客户来源列表
      let getCustomerSource = getCustomerSourceListForWepage()
      // 获取详情回显数据
      let id = this.$route.query.id
      let getWePageDetails = getWePageDetail(id)
      Promise.all([getAttr, getPublic, getCustomerSource, getWePageDetails]).then(res => {
        // 处理属性获取
        if (res[0].data.code == 200) {
          // 获取费内置常用属性
          this.attrs = res[0].data.result.filter(function(item) {
            if (item.isInner === 0 && item.isNormal === 1){
              return item
            }
          })
          for (let i in this.attrs) {
            this.attrs[i].label = this.attrs[i].name
            this.attrs[i].val = ''
            this.attrs[i].choosed = false
            this.attrs[i].itemShowModel = false
            this.attrs[i].itemMustWrite = false
          }
        }
        // 处理获取的公众号列表
        if (res[1].data.code === 0) {
          for (let one of res[1].data.data.list) {
            if (one.is_disable === 1) {
              one.disabled = true
            }
          }
          this.publics = res[1].data.data.list
        }
        // 处理获取的客户来源列表
        if (res[2].data.code === 0) {
          this.sources = res[2].data.data.list
        }
        // 处理详情回显数据
        if (res[3].data.code === 0) {
          this.tagsArray = res[3].data.data.tags
          let data = res[3].data.data
          // 循环显示被选中的
          // 循环去掉手机验证
          for (let i in data.identity) {
            if (data.identity[i].identity === 'verify_code') {
              data.identity.splice(i, 1)
            }
          }
          for (let item of this.attrs) {
            for (let one of data.identity) {
              one.label = one.name
              one.itemShowModel = false
              if (item.identity === one.identity) {
                item.choosed = true
                one.type = item.type
                if (one.is_require === 1) {
                  one.itemMustWrite = true
                } else {
                  one.itemMustWrite = false
                }
              }
            }
          }
          this.attrPhoneArrayCoby = data.identity
          this.attrPhoneArray = JSON.parse(JSON.stringify(this.attrPhoneArrayCoby))
          // 回显其他
          this.phoneImg = data.cover_img
          this.titleNameSend = data.name
          this.ruleForm.link = data.redirect_url
          this.ruleForm.tips = data.return_msg
          if (data.is_share === 0) {
            this.ruleForm.canDo.push('禁止分享')
          }
          if (data.authorization === 1) {
            this.ruleForm.canDo.push('访问页面时请求授权')
          }
          if (data.is_once === 1) {
            this.ruleForm.canDo.push('每个用户限填一次')
          }
          this.ruleForm.admin_title = data.admin_title
          this.ruleForm.customerSource = data.source_id
          this.ruleForm.sourceDesc = data.source_content
          this.ruleForm.isVerifyMobile = data.is_send_sms
          this.ruleForm.submitLimit = data.submit_limit
        }
      })
    }
  },
  created() {
    this.load()
  }
}
</script>

<style scoped>
.radio-content{
  height: auto;
  padding-top: 20px;
  width: 90%;
}
.radio-name{
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  font-size: 10px;
  height: 20px;
  line-height: 20px;
  color: #999;
  text-align: left;
}
.checkbox-name{
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  font-size: 10px;
  height: 20px;
  line-height: 20px;
  color: #999;
  text-align: left;
}
.ele-div {
  height: auto;
  width: 90%;
  margin: 0 auto;
  line-height: 40px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  color: #c0c4cc;
  background-color: #f5f7fa;
}
.ele-div p {
  text-align: left;
}
.operation-tips{
  height: 40px;
  background: #F0F2F5;
  border-radius: 4px 4px 0 0;
  line-height: 40px;
  padding-left: 10px;
  text-align: left;
  color: #333333;
}
.micro-page-add{
  width: calc(100% - 40px);
  min-height: 100%;
  margin: 20px auto 0;
  background-color: #F0F2F5;
}
.steps{
  width: 100%;
  height: 61px;
  background: #fff;
  margin: 0 auto 20px;
  padding-top: 59px;
}
.line{
  width: 600px;
  height: 1px;
  background: #c3c3c3;
  position: relative;
  margin: 0 auto;
}
.line-one{
  width: 300px;
  height: 1px;
  background: #c3c3c3;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.line-two{
  width: 300px;
  height: 1px;
  background: #c3c3c3;
  position: absolute;
  left: 300px;
  top: 0;
  z-index: 1;
}
.first-step{
  width: 60px;
  height: 60px;
  background: #c3c3c3;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 60px;
  position: absolute;
  left: -30px;
  top: -30px;
  z-index: 2;
}
.second-step{
  width: 60px;
  height: 60px;
  background: #c3c3c3;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 60px;
  position: absolute;
  left: 270px;
  top: -30px;
  z-index: 2;
}
.third-step{
  width: 60px;
  height: 60px;
  background: #c3c3c3;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 60px;
  position: absolute;
  right: -30px;
  top: -30px;
  z-index: 2;
}
.step-active{
  background: #679CFF;
}
.top-nav {
  width: 300px;
  height: 50px;
}
.left-title {
  width: 150px;
  float: left;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  background: #fff;
  color: #333;
  font-weight: bold;
  cursor: pointer;
}
.isAttr{
  background: #679CFF;
  color: #fff;
}
.nav-tips{
  height: 14px;
  font-size: 12px;
  color: #999;
  line-height: 14px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.nav-tips span{
  color: #679CFF;
}
.attr-item{
  width: 120px;
  float: left;
  height: 40px;
  border: 1px solid #999;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  margin: 7px 14px 0;
  color: #999;
  font-size: 14px;
  position: relative;
  cursor: pointer;
}
.other-set div{
  width: 120px;
  float: left;
  height: 40px;
  border: 1px solid #999;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  margin: 7px 14px 0;
  color: #999;
  font-size: 14px;
  position: relative;
  cursor: pointer;
}
.attr-item i{
  display: block;
  border: 1px solid #999;
  border-radius: 50%;
  width: 10px;
  height: 12px;
  text-align: center;
  padding-right: 2px;
  line-height: 14px;
  position: absolute;
  top: 14px;
  right: 10px;
}
.attr-item span {
  display: inline-block;
  height: 14px;
  line-height: 14px;
  width: 110px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  outline: none;
}
.main-content {
  width: 100%;/*calc(100% - 20px);*/
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  background-color: #F0F2F5;
}
.left-choose {
  width: 386px;
  height: 1004px;
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
}
.right-show {
  margin-left: 20px;
  /*min-width: 400px;*/
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.phone-content{
  margin: 50px auto;
  width: 400px;
  height: 758px;
  background: url("../../assets/images/mobile_phone_frame.png") no-repeat center center;
  background-size: 100% 100%;
  padding-top: 70px;
}
.show-content {
  width: 320px;
  height: 681px;
  margin-left: 40px;
  overflow: auto;
  overflow-x: hidden;
}
.top-title{
  width: 100%;
  height: 35px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: #FFF;
  margin-bottom: 10px;
}
.top-title div {
  width: 100%;
  height: 30px;
  margin: 0 auto;
  background: #fff;
  border-radius: 4px;
  color: #999;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.top-title span {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.avatar-uploader-phone{
  width: 100%;
  height: auto;
  cursor: pointer;
}
.useNowPhoneImg{
  display: block;
  width: 100%;
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
}
.defaultPhoneImg {
  display: block;
  width: 50%;
  margin-left: 25%;
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
}
.useNowPhoneImg{
  width: 100%;
  height: auto;
  display: block;
}
.submit-btn{
  width: 90%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  background: #679CFF;
  border-radius: 2px;
  margin: 10px auto;
}
.choosed, .choosed i{
  border: 1px solid #679CFF;
  color: #679CFF;
}
.attr-phone-item{
  position: relative;
  margin-top: 10px;
}
.item-model{
  background: #000;
  opacity: 0.6;
  position: absolute;
  left: 5%;
  right: 5%;
  bottom: 0;
  top: 0;
  border-radius: 2px;
  display: flex;
  z-index: 100;
  align-items: center;
  justify-content: space-around;
}
.item-model div {
  width: 80px;
  height: 40px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
}
.item-model div:hover,.item-model div:hover i{
  color: #679CFF;
}
.item-model div i{
  display: block;
  width: 80px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #fff;
}
.must-write{
  width: 5%;
  height: 30px;
  padding-top: 10px;
  position: absolute;
  left: 0;
  top: 0px;
  font-size: 20px;
  color: red;
}
.must-write-radio {
  width: 5%;
  height: 30px;
  padding-top: 10px;
  position: absolute;
  left: 0;
  top: -8px;
  font-size: 20px;
  color: red;
}
.demo-ruleForm{
  width: 530px!important;
  margin: 20px auto;
  overflow-x: hidden;
}
.publish-save-content{
  width: 300px;
  border-radius: 4px;
  background: #FAFAFC;
  padding-bottom: 20px;
  margin: 0 auto;
}
.third-content {
  padding-top: 60px;
  background-color: #fff;
  height: 800px;
}
.third-content p span{
  color: red;
}
.operation-content{
  width: 300px;
  height: 40px;
  margin: 0 auto;
  margin-top: 30px;
}
.bottom-pre{
  width: 200px;
  height: 40px;
  margin: 100px auto 0;
}
.description-date{
  width: 76%;
  color: #1980ff;
  padding-left: 24%;
  text-align: left;
}
.text-align-left{
  text-align: left;
}
.date-type{
  width: 203px;
  display: flex;
  justify-content: space-between;
}
.date-type .dateChoose{
  border: 1px solid #1980ff!important;
  color: #1980ff!important;
}
.date-type div{
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #666;
  border: 1px solid #e5e5e5;
  cursor: pointer;
}
.date-type div:first-child{
  border-right: none;
}
::-webkit-scrollbar
{
  width: 6px;  /*滚动条宽度*/
  height: 16px;  /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;  /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5;/*滚动条的背景颜色*/
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
  border-radius: 10px;  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #ccc;  /*滚动条的背景颜色*/
}
.addSelectItem{
  width: 90%;
  height: 30px;
  line-height: 30px;
  color: #1980ff;
  text-align: center;
  cursor: pointer;
  padding-right: 10%;
}
.removeSelectItem{
  width: 90%;
  height: 30px;
  line-height: 30px;
  color: red;
  text-align: right;
  cursor: pointer;
  padding-right: 10%;
}
.addMore{
  height: 300px;
  overflow: auto;
}
.normal{
  height: auto;
  overflow: hidden;
}
.tabs{
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
}
.tabs div{
  width: 82px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #666;
  border:1px solid #e5e5e5;
  border-left: none;
  cursor: pointer;
}
.tabs div:first-child{
  border: 1px solid #e5e5e5;
}
.tabs .type-select{
  border:1px solid #1980ff!important;
  color: #1980ff;
}
.tabs .edit-type-select{
  border:1px solid #1980ff!important;
  color: #1980ff;
  background: #ccc!important;
}
.addAttr{
  display: block;
  padding: 0 15px;
  height: 30px;
  background: #4882ff;
  color: #fff;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  float: right;
  margin-top: 5px;
  cursor: pointer;
}
.title-input {
  width: 300px!important;
}
.stockInput .el-input__inner{
  width: 270px !important;
}
.text-content {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.el-checkbox-group .el-checkbox__label {
  margin-right: 10px;
}
.confirm-btn {
  width: 90px;
  height: 36px;
  border-radius: 4px;
  background: #1980FF;
  border: none;
  color: #fff;
}
.item-model-content {
  display: flex;
  justify-content: center;
  flex-direction: row;
  line-height: 20px;
}
.item-model-content span {
  display: inline-block;
}
.item-model-content i {
  margin-right: -20px;
}
.item-model {
  vertical-align: middle;
}
</style>
